import { render, staticRenderFns } from "./createDestination.vue?vue&type=template&id=5f68a998&"
import script from "./createDestination.vue?vue&type=script&lang=js&"
export * from "./createDestination.vue?vue&type=script&lang=js&"
import style0 from "./createDestination.vue?vue&type=style&index=0&lang=scss&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports